import React, { useState } from 'react';
import context from 'utils/context';

const Provider = (props) => {
	const [ordersCount, setOrdersCount] = useState();
	return <context.Provider value={{ ordersCount, setOrdersCount }}>{props.children}</context.Provider>;
};

export default Provider;
